import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { presenceActions } from 'components/presence/actions/presenceActions';
import { hasFeature } from 'components/shared/featureFlag';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
import { AgentsWorkloadForm as AgentsWorkloadFormImpl, validateAgentsWorkloadForm, } from '../components/agentsWorkloadForm';
const { presenceGetWorkloadSettings, presenceSetWorkloadSettings } = presenceActions;
const FORM_NAME = 'agentsWorkloadForm';
const mapStateToProps = (state) => {
    return {
        initialValues: {
            workloadSettings: state.presence.workloadSettings,
        },
        workloadSettings: state.presence.workloadSettings,
        smsChannel: hasFeature(state, 'sms-channel'),
        twitterChannel: hasFeature(state, 'twitter-channel'),
    };
};
const mapDispatchToProps = (dispatch) => ({
    getWorkloadSettings() {
        dispatch({
            type: presenceGetWorkloadSettings.toString(),
        });
    },
    setWorkloadSettings: bindActionToPromise(dispatch, presenceSetWorkloadSettings),
});
const AgentsWorkloadForm = reduxForm({
    form: FORM_NAME,
    enableReinitialize: true,
    validate: validateAgentsWorkloadForm,
})(AgentsWorkloadFormImpl);
const AgentsWorkloadFormConnected = connect(mapStateToProps, mapDispatchToProps)(AgentsWorkloadForm);
export { AgentsWorkloadFormConnected as AgentsWorkloadForm };
